import BaseContainer from "@base/container/BaseContainer"
import {Signals} from "@/Imports";
import gsap from "gsap";
import FormatData from "@/application/FormatData";
import AddComponent from "@base/utils/AddComponent";
import Facade from "@/Facade";

export default class WinNumbersContainer extends BaseContainer {

  constructor(data) {
    super(data)

    Signals.startCountingUpWinnings.add(this.onStartShowWinnings, this)
    // Signals.startScatterAnimations.add(this.showWinNumberForScatter, this)
    // Signals.skip.add(this.onSkip, this)
    // Signals.skipForBuy.add(this.onSkip, this)
    // Signals.skipCountingUpWinnings.add(this.onSkipUpWinnings, this)
    // Signals.hideCountingUpWinnings.add(this.onHideUpWinnings, this)
    this.init()

  }

  init(data) {
    this.FINISH_SCALE = 1.5

    this.winText = AddComponent.addElementBitmapText('', {
      font: {name: 'fontWin', size: '180px'},
      align: 'center'
    }, this, [0, 20])
    this.winText.text = ""
    this.addChild(this.winText)

    this.hide()
  }

  onStartShowWinnings(data) {
    this.isDone = false
    this.isSkipped = false
    this.requireCounting = data.requireCounting
    this.finalWinnings = data.winnings
    this.showWinNumbers(data)
  }

  showWinNumbers = (data) => {
    this.textFieldReset()
    const time = data.bigwin ? data.bigwin.time : 0.5

    this.cont = {
      valueUI: data.startWin,
      valueBigWin: 0,
    }
    gsap.to(this.winText.scale, {
      duration: time,
      x: this.FINISH_SCALE,
      y: this.FINISH_SCALE,
    })

    let finalWinnings = this.finalWinnings
    if (this.requireCounting) {
      gsap.to(this.cont, {
        duration: time,
        valueUI: finalWinnings,
        valueBigWin: Facade.model.winCurrency,
        onUpdate: () => {
          const showWin = (this.cont.valueUI).toFixed(2)
          this.setWin(showWin)
          this.winText.text = this.cont.valueBigWin.toFixed(2);
        }, onComplete: () => {
          this.setWin(finalWinnings)
          Signals.winsCountupComplete.dispatch(finalWinnings)
        }
      });
    } else {
      Signals.winsCountupComplete.dispatch(finalWinnings)
      this.winText.text = FormatData.formatToCoins(finalWinnings)
      this.setWin(finalWinnings)
    }

    this.show()
  }

  hide() {
    this.winText.visible = false
  }

  show() {
    this.winText.visible = true
  }

  textFieldReset() {
    gsap.killTweensOf(this.winText.scale)
    gsap.killTweensOf(this.cont)
    gsap.killTweensOf(this.winText)
    this.winText.scale.set(1)
  }

  setWin(value) {
    Signals.setWin.dispatch(value)
  }
}
